var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{attrs:{"id":"on-off-checkbox"}},[_c('b-form-checkbox',{attrs:{"switch":"","disabled":_vm.disabled},on:{"change":function($event){return _vm.onChangeConfig($event)}},model:{value:(_vm.content),callback:function ($$v) {_vm.content=$$v},expression:"content"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }